import CarouselItemImageBackdrop from "./CarouselItemImageBackdrop";

export interface VenueImageCarouselItemProps {
  id: string;
  imageUrl: string;
  alt?: string;
}

export default function VenueImageCarouselItem({
  imageUrl,
  alt = "Carousel image",
}: VenueImageCarouselItemProps) {
  return (
    <div className="w-full flex-shrink-0 snap-center bg-white shadow-lg overflow-hidden relative md:hover:cursor-grab md:active:cursor-grabbing">
      <div className="flex h-[300px] md:h-[400px] relative">
        <CarouselItemImageBackdrop
          imageUrl={imageUrl}
          alt={alt}
          showGradient={false}
          objectFit="contain" // for image carousel items, cover the whole carousel item in the image (crop it)
        />
      </div>
    </div>
  );
}
